import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.scss";
import { routes } from "./route/Route";
import PrivateRoute from "./PrivateRoute";
import { useContext } from "react";
import { UserContext } from "./Context";
import Header from "../src/component/header/Header";
import Sidebar from "../src/component/sidebar/Sidebar";
import { ToastContainer } from "react-toastify";
import Loader from "./component/loader/Loader";

function App() {
  const { user, loader } = useContext(UserContext);
  const location = useLocation();
  return (
    <>
      <ToastContainer />
      {loader && <Loader />}

      {user && location.pathname !== "/login" && <Sidebar />}
      {/* {user && <Header />} */}
      <Routes>
        {routes.map((item, index) => (
          <Route
            key={index}
            path={item.path}
            element={
              item.isPublic ? (
                <item.element />
              ) : (
                <PrivateRoute superAdminOnly={item.superAdminOnly}>
                  <item.element />
                </PrivateRoute>
              )
            }
          />
        ))}
      </Routes>
    </>
  );
}

export default App;
